import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

interface FormInputContainerProps {
  required: boolean;
  label?: string;
  helperText?: string;
  errorMessage?: string | null | undefined;
  children: ReactNode;
  hidden?: boolean;
}

const StyledInputWrapper = styled.div`
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  flex-direction: column;
  gap: 0.4rem;

  input {
    height: 40px;
    padding: 0 16px;
    outline: none;
    width: 100%;
    border: 1px solid ${({ theme }) => theme?.palette?.inputBorder};
    border-radius: ${({ theme }) => theme?.radius?.input};
  }

  &.error {
    input {
      border: 1px solid red;
    }
  }

  .error-message {
    color: ${({ theme }) => theme.palette.danger};
    font-size: ${({ theme }) => theme.fontSize?.xs ?? '0.75rem'};
    margin: 0;
  }

  .required {
    &:after {
      content: ' *';
    }
  }
`;
export const FormInputWrapper: FC<FormInputContainerProps> = ({ required, label, helperText, errorMessage, children, hidden }) => {
  return (
    <StyledInputWrapper className={classNames({ error: errorMessage })} hidden={hidden}>
      {label && <label className={classNames({ required: required })}>{label}</label>}
      {children}
      {helperText && <p style={{ margin: 0, fontSize: '0.75rem', color: '#6b7280' }}>{helperText}</p>}
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </StyledInputWrapper>
  );
};
